import { Col, Flex, notification, Row } from "antd";

import { FinanceManagerFinancialsChartsCard } from "./finance-manager-financials-charts-card/FinanceManagerFinancialsChartsCard";
import { FinanceManagerFinancialsDatatablesCard } from "./finance-manager-financials-datatables-card/FinanceManagerFinancialsDatatablesCard";
import { useEffect } from "react";
import { useFinancialsInfo } from "financials/queries";
import { NotesList } from "notes/components";
import variables from "../../../../_variables.scss";
import { SalesTargetTimePeriods } from "users/components";
import { useBoundStore } from "store";

export const FinanceManagerDashboard = () => {
  const { currentOrganization } = useBoundStore();
  const {
    data: financialsInfo,
    isSuccess,
    error,
    refetch,
  } = useFinancialsInfo(currentOrganization?.id);
  const [api, notificationContextHolder] = notification.useNotification();

  const onSalesTargetTimePeriodChange = () => {
    refetch();
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Error",
        description: (error as Error)?.message,
      });
    }
  }, [error, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Flex>
        <SalesTargetTimePeriods
          name='sales-target-time-periods'
          onChange={onSalesTargetTimePeriodChange}
        />
      </Flex>
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 32 }} justify={"space-between"}>
        <Col span={16}>
          <FinanceManagerFinancialsChartsCard
            loading={!isSuccess}
            depositStatuses={financialsInfo?.depositStatuses}
            openAccountsReceivableStatuses={financialsInfo?.openAccountsReceivableStatuses}
          />
        </Col>
        <Col span={8}>
          <NotesList title={"My Project Notes"} showCard />
        </Col>
      </Row>
      <FinanceManagerFinancialsDatatablesCard
        loading={!isSuccess}
        openAccountsReceivableIncentive={financialsInfo?.openAccountsReceivableIncentive}
        openAccountsReceivableFinanced={financialsInfo?.openAccountsReceivableFinanced}
        openAccountsReceivableCustomerDirect={financialsInfo?.openAccountsReceivableCustomerDirect}
        openProjectsDepositsReceived={financialsInfo?.openProjectsDepositsReceived}
      />
    </Flex>
  );
};
